// src/components/thankyou/ThankYouPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import {Bounce} from 'react-awesome-reveal';
import './ThankYou.css';

const ThankYouPage = () => {
  return (
    <div className="thank-you-page">
      
      <div className="thank-you-message">
      <p className='tier' >Poornima University has achieved <span>Tier-1</span> globally</p>
        <Bounce>
        <h1>Thank You to All Participants!</h1>
        </Bounce>
        <p>
          We sincerely appreciate everyone who participated in the <span className="highlight-text">GenAI Study Jams & Arcade</span>. Your hard work and dedication have been essential in making this initiative a success.
        </p>
        <p>
          A special congratulations to those who completed all 15 skill badges and the arcade game, securing their place on the Top-80 in  leaderboard. Well done!
        </p>
        <p>
          To all participants, whether you made it to the top 80 or not, your efforts are deeply valued. Your participation and growth are what truly matter, and we encourage you to keep advancing in your learning journey.
        </p>
        <p>
          We will bring more exciting opportunities for all. Stay tuned!
        </p>
        
        <div className="buttons-below">
        <Link to="/leaderboard-marking-scheme">
          <button className="view-leaderboard-btn">Ranking Policy</button>
        </Link>

        <Link to="/leaderboard">
          <button className="view-leaderboard-btn">View Leaderboard</button>
        </Link>

        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
